<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 筛选区 + 统计，与表格拼接成整块白卡 -->
    <div class="filter-bar">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="门店ID" size="small">
          <el-input
            v-model="listQuery.store_id"
            placeholder="请输入门店ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="会员手机号" size="small">
          <el-input
            v-model="listQuery.user_phone"
            placeholder="请输入会员手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="核销人手机号" size="small">
          <el-input
            v-model="listQuery.cancel_phone"
            placeholder="请输入核销人手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="item-search">
          <el-button type="primary" @click="handleSearch" size="small" v-waves
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="filter-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 条记录
      </div>
    </div>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        :height="tableHeight"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="amount" slot-scope="{ row }">
          <el-tag v-if="row.amount < 0" type="danger" effect="dark" size="mini">
            {{ row.amount }}
          </el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">
            {{ row.amount }}
          </el-tag>
        </template>
        <template slot="user_id" slot-scope="{ row }">
          <el-tag
            v-if="!row.user_id"
            type="danger"
            effect="dark"
            size="mini"
          >
            会员暂未登录
          </el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">
            {{ row.user_id }}
          </el-tag>
        </template>
        <!-- <template slot="state" slot-scope="scope">
           <FillingStatus :value="scope.row" />
        </template>
        <template slot="fillRate" slot-scope="scope">
          <Percentage :value="scope.row"></Percentage>
        </template> -->
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
              disabled
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import { selectVipcardRecode } from "@/services/mini/vipcardRecode.js";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
  },
  async created() {
    this.getListData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      loading: false,
      /* 视口高度，用于计算表格自适应高度 */
      winHeight: window.innerHeight,
      listQuery: {
        pageNumber: 1,
        pageSize: 15,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    /* 表格高度：按实际行数收缩，数据少时不再留出大片空白 */
    tableHeight() {
      const rows = this.loading ? 10 : Math.max(this.tableData.length, 1);
      const need = 48 + rows * 50;
      const max = this.winHeight - 300;
      return `${Math.max(Math.min(need, max), 200)}px`;
    },
  },
  watch: {},
  methods: {
    handleResize() {
      this.winHeight = window.innerHeight;
    },
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectVipcardRecode(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 删除 */
    handleDelete(row) {
      // this.$confirm(`确定删除手机号为"${row.phone}"的用户吗?`, "禁用", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then((res) => {
      //   deleteUser({ id: row.id }).then((res) => {
      //     if (res.code === 200) {
      //       this.getListData();
      //       this.$message({
      //         type: "success",
      //         message: "删除成功!",
      //       });
      //     }
      //   });
      // });
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 筛选区：白色圆角卡片上半部，与表格拼接成一整块白卡 */
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  margin: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  /* 筛选项占满左侧，换行时整体仍对齐 */
  .filter-form {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-right: 16px;
    margin-bottom: 8px;

    .el-input__inner {
      width: 200px;
    }
  }
  /* 搜索按钮无 label，单独上移一点与输入框视觉对齐 */
  .item-search {
    margin-top: -6px;
  }

  /* 右侧统计，填补右端空白、平衡一行视觉重心 */
  .filter-meta {
    flex-shrink: 0;
    padding-top: 6px;
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  margin: 0;
  padding: 0 16px 20px;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
